import chevronLeft from "@assets/images/chevron-left.svg";
import EOrderingLogo from "@assets/images/eOrdering.png";
import SCGPLogo from "@assets/images/SCGP-color.svg";
import FormSpacer from "@saleor/components/FormSpacer";
import MyTypography from "@saleor/components/MyTypography";
import React from "react";
import { FormattedMessage } from "react-intl";

import useStyles from "../styles";

export interface ResetPasswordInvalidPageProps {
  onBack: () => void;
}

const ResetPasswordInvalidPage: React.FC<ResetPasswordInvalidPageProps> = props => {
  const { onBack } = props;

  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <div className={classes.mainPanel}>
        <div className={classes.headTextLogo}>
          <div className={classes.text}>
            <img src={SCGPLogo} alt="SCG Logo" />
          </div>
          <div className={classes.logo}>
            <img src={EOrderingLogo} alt={"logo"} />
          </div>
        </div>
        <MyTypography variant="h5" className={classes.header}>
          <FormattedMessage defaultMessage="Invalid Reset Link" />
        </MyTypography>
        <MyTypography variant="body3" className={classes.description}>
          <FormattedMessage defaultMessage="Sorry, this reset password link doesn't look valid anymore. You can try resetting your password again." />
        </MyTypography>
        <FormSpacer space={100} />
        <MyTypography
          className={classes.linkBack}
          onClick={onBack}
          variant="body3"
          data-testid="login-link"
        >
          <img src={chevronLeft} alt="Back to Reset Password" />
          <FormattedMessage
            defaultMessage="Back to Reset Password"
            description="description"
          />
        </MyTypography>
      </div>
    </div>
  );
};

export default ResetPasswordInvalidPage;
